"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreThemes = require("@vfuk/core-themes");
var _coreMatchMedia = require("@vfuk/core-match-media");
var _coreParagraph = _interopRequireDefault(require("@vfuk/core-paragraph"));
var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));
var _coreLink = _interopRequireDefault(require("@vfuk/core-link"));
var _uuid = require("uuid");
var _coreBaseProps = require("@vfuk/core-base-props");
var _BreadcrumbText = _interopRequireDefault(require("./components/BreadcrumbText"));
var Styled = _interopRequireWildcard(require("./styles/Breadcrumbs.style"));
var _Breadcrumbs2 = _interopRequireDefault(require("./themes/Breadcrumbs.theme"));
var _getBreadcrumbsArray = _interopRequireDefault(require("./helpers/getBreadcrumbsArray"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /* eslint-disable complexity, sonarjs/cognitive-complexity, max-len */
var Breadcrumbs = function Breadcrumbs(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    items = _ref.items,
    onClick = _ref.onClick,
    srText = _ref.srText,
    id = _ref.id,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    dataAttributes = _ref.dataAttributes,
    localTheme = _ref.localTheme;
  var componentName = 'Breadcrumbs';
  var breadcrumbsTheme = (0, _coreThemes.useLocalTheme)(componentName, _Breadcrumbs2["default"], localTheme);
  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
    sm = _useBreakpoints.sm,
    mdAndAbove = _useBreakpoints.mdAndAbove;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBreadcrumbOpen = _useState2[0],
    setIsBreadcrumbOpen = _useState2[1];
  var handleDotsClick = function handleDotsClick() {
    setIsBreadcrumbOpen(true);
  };
  var _breadcrumbsTheme$app = breadcrumbsTheme.appearance[appearance],
    inverseText = _breadcrumbsTheme$app.inverseText,
    inverseIcon = _breadcrumbsTheme$app.inverseIcon,
    iconAppearance = _breadcrumbsTheme$app.iconAppearance;
  return /*#__PURE__*/_react["default"].createElement(Styled.BreadcrumbsWrapper, _extends({
    breadcrumbsTheme: breadcrumbsTheme,
    appearance: appearance,
    "aria-label": srText,
    id: id,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName
  }, dataAttributes), /*#__PURE__*/_react["default"].createElement(Styled.Breadcrumbs, {
    role: "menu"
  }, (0, _getBreadcrumbsArray["default"])(items, isBreadcrumbOpen).map(function (item, index, breadCrumbArray) {
    var lastBreadcrumbItem = breadCrumbArray.length - 1;
    return /*#__PURE__*/_react["default"].createElement(Styled.BreadcrumbsItem, {
      key: index,
      role: "menuitem",
      "aria-current": lastBreadcrumbItem === index ? 'page' : undefined
    }, lastBreadcrumbItem !== index || sm ? /*#__PURE__*/_react["default"].createElement(_coreLink["default"], {
      id: item.id ? item.id : (0, _uuid.v4)(),
      href: item.href,
      size: 1,
      showUnderline: true,
      onClick: item.text === '...' ? handleDotsClick : onClick,
      customRouterProps: item.customRouterProps,
      inverse: inverseText,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "item-".concat(index))
    }, /*#__PURE__*/_react["default"].createElement(_BreadcrumbText["default"], _extends({}, item, {
      isSideBreadcrumbsItem: index === 0 || index === lastBreadcrumbItem,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "item-text-".concat(index))
    }))) : /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], {
      size: 1,
      weight: 3,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "item-".concat(index)),
      inverse: inverseText
    }, /*#__PURE__*/_react["default"].createElement(_BreadcrumbText["default"], _extends({}, item, {
      isSideBreadcrumbsItem: index === 0 || index === lastBreadcrumbItem,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "item-text-".concat(index))
    }))), !(index === lastBreadcrumbItem && mdAndAbove) ? /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
      appearance: iconAppearance,
      inverse: inverseIcon,
      name: mdAndAbove ? 'chevron-right' : 'chevron-left',
      size: 1,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "chevron-icon-".concat(index))
    }) : null);
  })));
};
Breadcrumbs.displayName = "Breadcrumbs";
var _default = Breadcrumbs;
exports["default"] = _default;
//# sourceMappingURL=Breadcrumbs.js.map